import React from 'react';
import cx from 'classnames';
import HeaderBar from '@/components/HeaderBar';
import MissedPayment from '@/components/MissedPayment';
import Watermark from '@/components/Watermark';
import { useBraze } from '@/hooks/braze';
import { useGetMissedPayment } from '@/hooks/premium';
import { useCurrentUser } from '@/hooks/user';
import { setAnalyticsPid } from '@/utilities/analytics';
import { isFeatureEnabled } from '@separate/utilities/features';
import styles from './index.module.scss';

/* eslint react/prop-types: 0 */
export default function Layout({ Component, pageProps }) {
  // place for a query dependent hooks
  useBraze();
  const isMissedPaymentFlowEnabled = isFeatureEnabled('allow_missed_payment_flow');

  const {
    userHasMissedPayment,
    showMissedPaymentModal,
    setShowMissedPaymentModal,
    showMissedPaymentBanner,
    setShowMissedPaymentBanner,
  } = useGetMissedPayment();

  const { user } = useCurrentUser();
  const pid = user?.pid;

  React.useEffect(() => {
    if (!pid) return;

    setAnalyticsPid(pid);
  }, [pid]);

  return (
    <div className={cx(styles.maxWidth, {
      [styles.showMissedPaymentBanner]: showMissedPaymentBanner && userHasMissedPayment
    })}>
      {!Component.suppressHeaderBar && (
        <>
          <HeaderBar />
          {isMissedPaymentFlowEnabled && (
            <MissedPayment
              userHasMissedPayment={userHasMissedPayment}
              showMissedPaymentModal={showMissedPaymentModal}
              setShowMissedPaymentModal={setShowMissedPaymentModal}
              showMissedPaymentBanner={showMissedPaymentBanner}
              setShowMissedPaymentBanner={setShowMissedPaymentBanner}
            />
          )}
        </>
      )}
      <div className={Component.suppressHeaderBar ? "componentNoHeader" : "component"}>
        <Component {...pageProps} />
      </div>
      {!Component.suppressFooter &&
        <Watermark />
      }
    </div>
  );
}
